import { useUser } from "@auth0/nextjs-auth0"
import { UserId } from "@wise/identities"
import { useEffect, useState } from "react"
import { postCalculations } from "../../credits/api/postCalculations"
import { isError } from "../../utils/type"
import { getColumnsWithType } from "../services/getColumnsWithType"
import { DataColumn, DataColumnWithType } from "../types"

interface Props {
    allColumns: DataColumn[]
    dimensions:
        | {
              rows: number
              columns: number
          }
        | undefined
    setColumnsWithType: (columns: DataColumnWithType[]) => void
}

export function useColumnTypes({ allColumns, dimensions, setColumnsWithType }: Props) {
    const [loading, setLoading] = useState(false)
    const { user } = useUser()

    useEffect(() => {
        if (allColumns.length === 0) {
            return
        }
        if (dimensions == null) {
            return
        }

        setLoading(true)

        const modPromise = import("@dqbd/tiktoken")

        modPromise
            .then((mod) => {
                const encoding = mod.encoding_for_model("text-embedding-ada-002")

                const columnsWithType = getColumnsWithType({
                    allColumns,
                    dimensions,
                    encoding,
                })

                postCalculations({
                    items: columnsWithType.map((c) => ({
                        quantity: c.quantity,
                        productId: c.type,
                    })),
                    userId: user?.sub ? new UserId(user.sub, process.env.NEXT_PUBLIC_AUTH0_TENANT) : undefined,
                })
                    .then((res) => {
                        setColumnsWithType(columnsWithType.map((c, i) => ({ ...c, cost: res.items[i].total })))
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            })
            .catch((err) => {
                console.error(err)
                isError(err) && window && window.newrelic.noticeError(err)
                setLoading(false)
            })
    }, [allColumns, dimensions, setColumnsWithType, user?.sub])

    return {
        loading,
    }
}
